<ng-container
  *finLet="{
    enabledStatus: twoFactorAuthService.enabledStatus$ | async,
    lastUpdateStatus: (twoFactorAuthService.lastUpdateStatus$ | async)?.status,
  } as twoFactorAuth"
>
  <div
    *ngIf="
      twoFactorAuth.enabledStatus.status === TwoFactorAuthStatus.INITIAL &&
      twoFactorAuth.lastUpdateStatus === TwoFactorAuthStatus.LOADING
    "
    class="relative loader"
    data-testid="loyalty-two-factor-auth-toggle-loading-container"
  >
    <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
  </div>

  <div
    *ngIf="
      twoFactorAuth.enabledStatus.status === TwoFactorAuthStatus.INITIAL &&
      twoFactorAuth.lastUpdateStatus === TwoFactorAuthStatus.ERROR
    "
    data-testid="loyalty-two-factor-auth-toggle-status-error-container"
  >
    <fcom-notification
      [theme]="NotificationTheme.ALERT"
      [buttonStyle]="NotificationButtonStyle.LINK"
      [linkText]="'actions.tryAgain' | finLocalization"
      (linkClick)="onTwoFactorAuthErrorStatusNotificationTryAgainLinkClick()"
    >
      {{ 'plus.profile.twoFactorAuthStatusError' | finLocalization }}
    </fcom-notification>
  </div>

  <div *ngIf="twoFactorAuth.enabledStatus.isEnabled" data-testid="loyalty-two-factor-auth-toggle-enabled-container">
    <fcom-notification
      [buttonStyle]="NotificationButtonStyle.LINK"
      [linkText]="
        enabledBackButtonUrl
          ? ('plus.profile.twoFactorAuth.enabledNotification.continueLinkingYourAccountsButton' | finLocalization)
          : ''
      "
      [linkUrl]="enabledBackButtonUrl"
      (linkClick)="onBackButtonLinkClick()"
      class="mr-small-b"
      data-testid="loyalty-two-factor-auth-toggle-enabled-notification"
    >
      <div
        *ngIf="enable2faEmailVerification; else genericTwoFactorAuthEnabled"
        [innerHTML]="
          (twoFactorAuth.enabledStatus.type === TwoFactorAuthType.APP
            ? 'plus.profile.twoFactorAuthAppEnabled'
            : twoFactorAuth.enabledStatus.type === TwoFactorAuthType.SMS
              ? 'plus.profile.twoFactorAuthSmsEnabled'
              : 'plus.profile.twoFactorAuthEmailEnabled'
          ) | finLocalization
        "
      ></div>

      <ng-template #genericTwoFactorAuthEnabled>
        {{ 'plus.profile.twoFactorAuthEnabled' | finLocalization }}
      </ng-template>
    </fcom-notification>
    <div class="align-right">
      <fcom-button
        [text]="'actions.disable' | finLocalization"
        [loading]="twoFactorAuth.lastUpdateStatus === TwoFactorAuthStatus.LOADING"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        (clickBtn)="isDisableConfirmationModalOpened = true"
        data-testid="loyalty-two-factor-auth-toggle-content-disable-gauth-button"
      >
      </fcom-button>
    </div>

    <fcom-modal
      #modal
      [(open)]="isDisableConfirmationModalOpened"
      [title]="'plus.profile.twoFactorAuth.disablingConfirmation.title' | finLocalization"
      [buttons]="ModalButtons.CUSTOM"
      [fitToContent]="true"
      (confirm)="disableGAuth()"
      data-testid="loyalty-two-factor-auth-toggle-disable-confirmation-modal"
    >
      <div
        class="pr-small"
        [innerHTML]="
          ((aviosLinkingStatus$ | async) === AviosAccountLinkingStatus.ACTIVE
            ? 'plus.profile.twoFactorAuth.disablingConfirmation.bodyText'
            : 'plus.profile.twoFactorAuth.disablingConfirmation.noLinkedAccountText'
          ) | finLocalization
        "
      ></div>

      <div buttons>
        <div class="flex flex--end">
          <fcom-button
            [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
            [text]="'actions.disable' | finLocalization"
            (clickBtn)="modal.onConfirm()"
            class="mr-xsmall-r"
          >
          </fcom-button>

          <fcom-button #cancelButton [text]="'actions.cancel' | finLocalization" (clickBtn)="modal.onClose()">
          </fcom-button>
        </div>
      </div>
    </fcom-modal>
  </div>

  <div
    *ngIf="twoFactorAuth.enabledStatus.status === TwoFactorAuthStatus.DISABLED"
    data-testid="loyalty-two-factor-auth-toggle-disabled-container"
  >
    <p class="mr-large-b">{{ 'plus.profile.twoFactorAuth.intro' | finLocalization }}</p>
    <p class="medium-type mr-small-b">{{ 'plus.profile.twoFactorAuth.select' | finLocalization }}:</p>

    <fcom-tabs
      [theme]="TabTheme.DEFAULT"
      [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
      [nextButtonAriaLabel]="'carousel.next' | finLocalization"
      (clickedTab)="resetAuthState(false)"
    >
      <fcom-tab
        *ngIf="enable2faEmailVerification"
        [title]="'plus.profile.twoFactorAuth.email.title' | finLocalization"
        [disabled]="isRequestLoading"
      >
        <ng-container *ngIf="authState === AuthState.CHOOSE_TYPE">
          <ol class="ms-large-l">
            <li class="medium-type ms-small-b">
              {{ 'plus.profile.twoFactorAuth.email.enableStep.0' | finLocalization }}
            </li>
            <li class="medium-type ms-small-b">
              {{ 'plus.profile.twoFactorAuth.email.enableStep.1' | finLocalization }}
            </li>
          </ol>

          <ng-container
            *ngIf="authError === AuthError.Enable2faEmail"
            [ngTemplateOutlet]="notification"
            [ngTemplateOutletContext]="{ text: 'plus.profile.twoFactorAuthFailed' | finLocalization }"
          ></ng-container>

          <div class="align-right mr-small-t mr-xxsmall-r">
            <fcom-button
              [text]="'plus.profile.enable' | finLocalization"
              [loading]="isRequestLoading"
              [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
              (clickBtn)="selectTwoFactorAuthType(TwoFactorAuthType.EMAIL)"
              data-testid="loyalty-two-factor-auth-toggle-email-choose-type-enable-button"
            >
            </fcom-button>
          </div>
        </ng-container>

        <ng-container *ngIf="authState === AuthState.VERIFY">
          <p
            [innerHTML]="
              'plus.profile.twoFactorAuth.email.verificationStep.description'
                | finLocalization: { email: (profile$ | async)?.email }
            "
            class="mr-large-b"
          ></p>

          <form
            (ngSubmit)="validateCode(TwoFactorAuthType.EMAIL)"
            [formGroup]="verificationForm"
            class="form-container service-form grow"
          >
            <div class="flex form-subgroup">
              <fin-form-input-text
                [id]="'email-verification-code'"
                [parentForm]="verificationForm"
                [controlName]="'verificationCode'"
                [translationPrefix]="'plus.profile.twoFactorAuth.email.verificationStep.fields'"
                [displayMargin]="false"
                [required]="true"
              ></fin-form-input-text>

              <div class="full-width ms-small-l">
                <fcom-button
                  [type]="ButtonType.SUBMIT"
                  [text]="'actions.verify' | finLocalization"
                  [loading]="twoFactorAuth.lastUpdateStatus === TwoFactorAuthStatus.LOADING"
                  [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
                  data-testid="loyalty-two-factor-auth-toggle-email-verify-submit-button"
                ></fcom-button>
              </div>
            </div>
          </form>

          <p class="ms-large-t">
            {{ 'plus.profile.twoFactorAuth.email.verificationStep.noCodeReceived' | finLocalization }}
            <fcom-link
              (afterNavigation)="send2faEmailVerificationCode(true)"
              data-testid="loyalty-two-factor-auth-toggle-email-verify-resend-link"
            >
              {{ 'actions.resend' | finLocalization }}
            </fcom-link>
          </p>

          <fcom-notification
            *ngIf="showSend2faEmailVerificationCodeSuccessNotification"
            [theme]="NotificationTheme.SUCCESS"
            [isClosable]="true"
            (closeClick)="showSend2faEmailVerificationCodeSuccessNotification = false"
            class="mr-xsmall-t"
            data-testid="loyalty-two-factor-auth-toggle-email-verify-resend-success-notification"
          >
            {{ 'plus.profile.twoFactorAuth.email.verificationStep.resendSuccess' | finLocalization }}
          </fcom-notification>

          <fcom-notification
            *ngIf="resendEmailCount >= 2"
            class="mr-xsmall-t"
            [theme]="NotificationTheme.WARNING"
            data-testid="loyalty-two-factor-auth-toggle-email-verify-still-no-code-received-notification"
          >
            {{ 'plus.profile.twoFactorAuth.email.verificationStep.stillNoCodeReceived' | finLocalization }}
          </fcom-notification>

          <ng-container
            *ngIf="authError === AuthError.ValidateCode"
            [ngTemplateOutlet]="notification"
            [ngTemplateOutletContext]="{ text: 'plus.profile.twoFactorAuthFailed' | finLocalization }"
          ></ng-container>
          <ng-container
            *ngIf="authError === AuthError.IncorrectCode"
            [ngTemplateOutlet]="notification"
            [ngTemplateOutletContext]="{
              text: 'plus.profile.twoFactorAuth.email.verificationStep.verifyError' | finLocalization,
            }"
          ></ng-container>

          <ng-container
            *ngIf="authError === AuthError.Resend2faEmail"
            [ngTemplateOutlet]="notification"
            [ngTemplateOutletContext]="{
              text: 'plus.profile.twoFactorAuth.email.verificationStep.resendError' | finLocalization,
            }"
          ></ng-container>

          <div class="flex flex--end mr-small-t mr-xxsmall-r">
            <fcom-button
              [text]="'actions.cancel' | finLocalization"
              [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
              [disabled]="isRequestLoading"
              [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
              (clickBtn)="resetAuthState()"
              data-testid="loyalty-two-factor-auth-toggle-email-verify-cancel-button"
            >
            </fcom-button>
          </div>
        </ng-container>
      </fcom-tab>
      <fcom-tab
        *ngIf="true"
        [title]="'plus.profile.twoFactorAuth.app.title' | finLocalization"
        [disabled]="isRequestLoading"
        tabTitleDataTestId="loyalty-two-factor-auth-toggle-disabled-tab-app"
      >
        <div *ngIf="authState === AuthState.CHOOSE_TYPE" data-testid="two-factor-auth-app-choose-type">
          <ol class="ms-large-l">
            <li class="medium-type ms-small-b">
              {{ 'plus.profile.twoFactorAuth.app.step.0' | finLocalization }}:
              <cms-unstyled-fragment
                [contentUrl$]="'fragments.twoFactorAuth.url' | finLocalization | finToObservable"
                class="light-type block ms-medium-t ms-large-b"
              ></cms-unstyled-fragment>
            </li>
            <li class="medium-type ms-small-b">{{ 'plus.profile.twoFactorAuth.app.step.1' | finLocalization }}</li>
          </ol>

          <ng-container
            *ngIf="authError === AuthError.Enable2faApp"
            [ngTemplateOutlet]="notification"
            [ngTemplateOutletContext]="{ text: 'plus.profile.twoFactorAuthFailed' | finLocalization }"
          ></ng-container>

          <div class="align-right mr-small-t mr-xxsmall-r">
            <fcom-button
              [text]="'plus.profile.twoFactorAuth.continue' | finLocalization"
              [loading]="isRequestLoading"
              [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
              (clickBtn)="selectTwoFactorAuthType(TwoFactorAuthType.APP)"
              data-testid="loyalty-two-factor-auth-toggle-app-choose-type-continue-button"
            >
            </fcom-button>
          </div>
        </div>
        <form
          *ngIf="authState === AuthState.VERIFY"
          [formGroup]="verificationForm"
          class="form-container service-form grow"
          (ngSubmit)="validateCode(TwoFactorAuthType.APP)"
          data-testid="loyalty-two-factor-auth-toggle-app-verify"
        >
          <ol start="3" class="ms-large-l">
            <li class="medium-type ms-small-b no-outline">
              {{ 'plus.profile.twoFactorAuth.app.step.2' | finLocalization }}
            </li>
            <li class="medium-type ms-small-b">{{ 'plus.profile.twoFactorAuth.app.step.3' | finLocalization }}</li>
          </ol>
          <span class="block pr-medium-t font-body-1 nordic-blue-900-text">{{
            'SERVICE_FORMS.serviceForms.mandatoryFields' | finLocalization
          }}</span>
          <div class="pr-xxsmall-y" *ngIf="qrCodeImageUrl$ | async as qrCodeImageUrl">
            <img alt="" [src]="qrCodeImageUrl" />
          </div>
          <div class="light-type font-body-1 ms-small-b">
            {{ 'plus.profile.secretKey' | finLocalization }}: {{ secretKey }}
          </div>
          <div class="flex form-subgroup mr-xsmall-t">
            <fin-form-input-text
              [id]="'app-verification-code'"
              [parentForm]="verificationForm"
              [controlName]="'verificationCode'"
              [translationPrefix]="'plus.profile.securityCode'"
              class="font-body-1"
            ></fin-form-input-text>

            <div class="full-width ms-small-l">
              <fcom-button
                [text]="'actions.verify' | finLocalization"
                [type]="ButtonType.SUBMIT"
                [loading]="twoFactorAuth.lastUpdateStatus === TwoFactorAuthStatus.LOADING"
                [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
                data-testid="loyalty-two-factor-auth-toggle-app-verify-submit-button"
              >
              </fcom-button>
            </div>
          </div>

          <ng-container
            *ngIf="authError === AuthError.ValidateCode || authError === AuthError.IncorrectCode"
            [ngTemplateOutlet]="notification"
            [ngTemplateOutletContext]="{ text: 'plus.profile.twoFactorAuthFailed' | finLocalization }"
          ></ng-container>

          <div class="flex flex--end mr-small-t mr-xxsmall-r">
            <fcom-button
              [text]="'plus.profile.twoFactorAuth.cancel' | finLocalization"
              [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
              [disabled]="isRequestLoading"
              [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
              (clickBtn)="resetAuthState()"
              data-testid="loyalty-two-factor-auth-toggle-app-verify-cancel-button"
            >
            </fcom-button>
          </div>
        </form>
      </fcom-tab>
      <fcom-tab
        *ngIf="!enable2faEmailVerification"
        [title]="'plus.profile.twoFactorAuth.sms.title' | finLocalization"
        [disabled]="isRequestLoading || twoFactorAuth.lastUpdateStatus === TwoFactorAuthStatus.LOADING"
      >
        <ng-container *ngIf="authState === AuthState.CHOOSE_TYPE || authState === AuthState.VERIFY">
          <ol class="ms-large-l">
            <li class="medium-type ms-small-b">{{ 'plus.profile.twoFactorAuth.sms.step.0' | finLocalization }}</li>
            <li class="medium-type ms-small-b">{{ 'plus.profile.twoFactorAuth.sms.step.1' | finLocalization }}</li>
          </ol>

          <ng-container
            *ngIf="authError === AuthError.Enable2faSms"
            [ngTemplateOutlet]="notification"
            [ngTemplateOutletContext]="{ text: 'plus.profile.twoFactorAuthFailed' | finLocalization }"
          ></ng-container>

          <div class="align-right mr-small-t mr-xxsmall-r">
            <fcom-button
              [text]="'plus.profile.enable' | finLocalization"
              [loading]="twoFactorAuth.lastUpdateStatus === TwoFactorAuthStatus.LOADING"
              [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
              (clickBtn)="openEnable2faSmsConfirmationModal($event)"
              data-testid="two-factor-auth-sms-enable-confirmation-modal-button"
            >
            </fcom-button>
          </div>
        </ng-container>
      </fcom-tab>
    </fcom-tabs>
  </div>

  <fcom-modal
    #modal
    [(open)]="isEnable2faSmsConfirmationModalOpen"
    [title]="
      ((parsedMobilePhone$ | async)
        ? 'plus.profile.twoFactorAuth.confirmationModalSms.heading'
        : 'plus.profile.twoFactorAuth.confirmationModalSms.headingMissingPhoneNr'
      ) | finLocalization
    "
    [buttons]="!!(parsedMobilePhone$ | async) ? ModalButtons.CUSTOM : ModalButtons.CLOSE"
    [confirmEnabled]="!!(parsedMobilePhone$ | async)"
    [fitToContent]="true"
    (confirm)="selectTwoFactorAuthType(TwoFactorAuthType.SMS)"
    data-testid="loyalty-two-factor-auth-toggle-enable-sms-confirmation-modal"
  >
    <div class="pr-large">
      <p *ngIf="parsedMobilePhone$ | async as phoneNumber">
        {{ 'plus.profile.twoFactorAuth.confirmationModalSms.body' | finLocalization: { phoneNumber } }}
      </p>
      <p *ngIf="!!(parsedMobilePhone$ | async) !== true">
        {{ 'plus.profile.twoFactorAuth.confirmationModalSms.bodyMissingPhoneNr' | finLocalization }}
      </p>
    </div>

    <ng-container buttons>
      <fcom-button
        class="close-modal-btn mr-xsmall-r"
        [text]="'actions.cancel' | finLocalization"
        [disabled]="!modal.open || modal.forceRemainOpen"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        (clickBtn)="modal.onClose()"
      >
      </fcom-button>
      <fcom-button
        class="confirm-modal-btn"
        [text]="'plus.profile.enable' | finLocalization"
        [disabled]="!modal.open || !modal.confirmEnabled || modal.forceRemainOpen"
        (clickBtn)="modal.onConfirm()"
      >
      </fcom-button>
    </ng-container>
  </fcom-modal>

  <ng-template #notification let-text="text">
    <fcom-notification
      aria-live="polite"
      class="mr-xsmall-t"
      [theme]="NotificationTheme.ALERT"
      [layout]="NotificationLayout.BLOCK"
      [isClosable]="true"
      [i18n]="{ closeAriaLabel: 'plus.profile.closeNotification' }"
      (closeClick)="onCloseError()"
    >
      {{ text }}
    </fcom-notification>
  </ng-template>
</ng-container>
